<!--
 * @Date: 2022-09-26 10:50:19
 * @LastEditors: shikexin shikexin0116@163.com
 * @LastEditTime: 2022-10-09 12:06:34
 * @description: description
-->
<template>
  <div :class="$style.aboutus">
    <!-- 关于我们 -->
    <AboutusBanner id="profile" :info="info.banner" />
    <!-- 核心价值 -->
    <SenseOfWorth id="values" :info="info.senseOfWorth" />
    <!-- 发展历程 -->
    <DevelopmentHistory
      id="history"
      :info="info.developmentHistory"
    />
    <!-- 资质荣誉 -->
    <Honor id="honor" :info="info.honor" />
    <!-- 我的伙伴 -->
    <Partner id="partner" :info="info.partner" />

  </div>
</template>
<script>
import AboutusBanner from './Banner.vue'
import SenseOfWorth from './SenseOfWorth.vue'
import DevelopmentHistory from './DevelopmentHistory.vue'
import Honor from './Honor.vue'
import Partner from './Partner.vue'

export default {
  name: 'aboutusPC',
  components: {
    AboutusBanner,
    SenseOfWorth,
    DevelopmentHistory,
    Honor,
    Partner
  },
  props: {
    info: Object
  },
  data () {
    return {
      queryAnchor: ''
    }
  },
  watch: {
    $route: {
      handler (to, from) {
        this.$nextTick(() => {
          if (this.$route.query.anchor) {
            const queryId = '#' + this.$route.query.anchor || 'profile'
            this.$el.querySelector(queryId).scrollIntoView()
          }
        })
      },
      // 第一次就执行
      immediate: true
    }
  },
  methods: {
    showScolltop (info) {
      if (!info) return
      const showId = '#' + info
      this.$el.querySelector(showId).scrollIntoView()
    }
  }
}
</script>

<style lang="scss" module>
.aboutus {
  position: relative;
  // width: max-content;
  // margin: 0 auto;
}
</style>
